import './App.css';
import './responsive.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import Aboutpage from './pages/Aboutpage';
import Gallerypage from './pages/Gallery';
import Media from './pages/Media';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import { HelmetProvider } from "react-helmet-async";
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';

function App() {

  const checkIfUserIsLoggedIn = () => {
    return localStorage.getItem('user') !== null;

  }
  const isLoggedIn = checkIfUserIsLoggedIn();


  return (
    <div className="App">
       <HelmetProvider>
      <Router>
        <Routes>    
          <Route index element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/about' element={<Aboutpage />} />         
          <Route path='/gallery' element={<Gallerypage />} />
          <Route path='/media' element={<Media />} />      
          <Route path='/terms-and-condition' element={<Terms />} />
          <Route path='/privacy-policy' element={<Privacy />} />
          <Route path='/contact' element={<Contact />} />        
          <Route path='/shop' element={< Shop/>} />
          
        <Route path="/category/:id" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        </Routes>
      </Router>

</HelmetProvider>

    </div>
  );
}

export default App;
